// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import styles from './index.scss'
import type {
  LocaleSwitcher_viewer as Viewer,
} from './__generated__/LocaleSwitcher_viewer.graphql'

type Props = $ReadOnly<{
  viewer: Viewer,
}>

const localeUrl = (viewerLocale: string) => {
  const newHostName = window.location.hostname.replace(/^[^\.]*/, viewerLocale)
  return window.location.href.replace(window.location.hostname, newHostName)
}

const localeSwitchId = (viewerLocale, siteLocale) => `switch_from_${siteLocale}_to_${viewerLocale}`

function LocaleSwitcher({viewer}: Props): Node {
  if (viewer.locale === I18n.locale)
    return null

  return (
    <div test-id="locale_switcher" className={styles.localeSwitcher}>
      <a
        test-id={localeSwitchId(viewer.locale, I18n.locale)}
        href={localeUrl(viewer.locale)}
        className="text-white"
      >
        {I18n.t('nav.switch_locale', {locale: viewer.locale})}
      </a>
    </div>
  )
}

export default (createFragmentContainer(LocaleSwitcher, {
  viewer: graphql`
    fragment LocaleSwitcher_viewer on Person {
      locale
    }
  `,
}): RelayFragmentContainer<typeof(LocaleSwitcher)>)
